// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5d925e7b","239":"788fbf37","667":"10f00417"}[chunkId] + ".chunk.js";
};